'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isPoint = require('./is-point.js');

var isPoint3D = function (point) {
  return isPoint.isPoint(point) && point.hasOwnProperty('z');
};

exports.isPoint3D = isPoint3D;
